import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { setVerificationGateListener } from "../utils/api";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import UiIcon from "./UiIcon";

// Compte non vérifié (voir OLTODO-backend/src/middleware/auth.ts#isExemptFromVerificationGate) :
// jusqu'ici chaque écran retombait sur son propre message d'erreur générique ("Erreur lors de
// l'envoi de la photo"...), qui masquait complètement la vraie cause. Interception globale ici,
// montée une seule fois à la racine (voir App.tsx, même précédent que CallOverlay) plutôt que
// dans chaque écran — écoute utils/api.ts#parseJsonSafe, le seul endroit par lequel passe toute
// réponse écrite.
export default function VerificationGateModal() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { lang } = useApp();

  useEffect(() => {
    setVerificationGateListener(() => setOpen(true));
    return () => setVerificationGateListener(null);
  }, []);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.6)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: 22, padding: 24, width: "100%", maxWidth: 380, boxSizing: "border-box" }}>
        <div style={{ width: 52, height: 52, borderRadius: 26, backgroundColor: "#0a0a0a", color: "white", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
          <UiIcon name="shieldCheck" size={26} />
        </div>
        <div style={{ fontSize: 19, fontWeight: 700, letterSpacing: "-0.01em", marginBottom: 8 }}>{t(lang, "vfy_track_not_verified")}</div>
        <div style={{ fontSize: 14, color: "#6B6B6B", lineHeight: 1.55, marginBottom: 22 }}>{t(lang, "vfy_gate_body")}</div>
        <button onClick={() => { setOpen(false); navigate("/verify-identity"); }} style={{ width: "100%", height: 50, borderRadius: 12, border: "none", backgroundColor: "#0a0a0a", color: "white", fontSize: 15, fontWeight: 600, cursor: "pointer", marginBottom: 8 }}>
          {t(lang, "vfy_gate_cta")}
        </button>
        <button onClick={() => setOpen(false)} style={{ width: "100%", height: 46, borderRadius: 12, border: "none", backgroundColor: "transparent", color: "#6B6B6B", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
          {t(lang, "vfy_gate_later")}
        </button>
      </div>
    </div>,
    document.body
  );
}
